import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import { setAlert } from './alert';
import {
    CREATE_REFUND_SUCCESS,
    CREATE_REFUND_ERROR,
    GET_REFUND_SUCCESS,
    GET_ALL_REFUNDS_SUCCESS,
    GET_PAYMENT_REFUNDS_SUCCESS,
    REFUND_LOADING,
    REFUND_ERROR,
    CLEAR_REFUND
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Create Refund
export const createRefund = (refundData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: REFUND_LOADING });
        const res = await axios.post(`${API_URL}/payment/create-refund`, refundData);
        dispatch({
            type: CREATE_REFUND_SUCCESS,
            payload: res.data
        });
        dispatch(setAlert(res.data.message || 'Refund created successfully', 'success'));
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message;
        dispatch({
            type: CREATE_REFUND_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get Refund Details
export const getRefundDetails = (refundId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: REFUND_LOADING });
        const res = await axios.get(`${API_URL}/payment/refund/${refundId}`);
        dispatch({
            type: GET_REFUND_SUCCESS,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message;
        dispatch({
            type: REFUND_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get All Refunds
export const getAllRefunds = (params = {}) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: REFUND_LOADING });
        
        const queryParams = new URLSearchParams();
        if (params.count) queryParams.append('count', params.count);
        if (params.skip) queryParams.append('skip', params.skip);
        if (params.paymentId) queryParams.append('paymentId', params.paymentId);
        
        const url = `${API_URL}/payment/refunds${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const res = await axios.get(url);
        
        dispatch({
            type: GET_ALL_REFUNDS_SUCCESS,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message;
        dispatch({
            type: REFUND_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get Refunds for a Specific Payment
export const getPaymentRefunds = (paymentId, params = {}) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: REFUND_LOADING });
        
        const queryParams = new URLSearchParams();
        if (params.count) queryParams.append('count', params.count);
        if (params.skip) queryParams.append('skip', params.skip);
        if (params.from) queryParams.append('from', params.from);
        if (params.to) queryParams.append('to', params.to);
        if (params.status) queryParams.append('status', params.status);
        
        const url = `${API_URL}/payment/payments/${paymentId}/refunds${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const res = await axios.get(url);
        
        dispatch({
            type: GET_PAYMENT_REFUNDS_SUCCESS,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message;
        dispatch({
            type: REFUND_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Get Specific Refund for a Payment
export const getPaymentRefund = (paymentId, refundId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    try {
        dispatch({ type: REFUND_LOADING });
        const res = await axios.get(`${API_URL}/payment/payments/${paymentId}/refunds/${refundId}`);
        dispatch({
            type: GET_REFUND_SUCCESS,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message;
        dispatch({
            type: REFUND_ERROR,
            payload: errorMessage
        });
        dispatch(setAlert(errorMessage, 'danger'));
        throw err;
    }
};

// Clear Refund
export const clearRefund = () => dispatch => {
    dispatch({ type: CLEAR_REFUND });
};

